import { axios } from '@/utils/request'
import { Dialog } from 'vant'
import { getUrlKey, resetUserSessionStorage } from '@/utils/util'
// 拦截器
/**
 * 此处为拦截器，通过判断返回值的code码来进行重复登录的判断
 * @param req
 * @constructor
 */
// 单点登录验证跳转待定
function Interceptor (req) {
  req.then((res) => {
    if (res.code === 1) {
      Dialog.alert({
        title: '提示',
        message: res.msg || `连接失效，请重新登录`,
        confirmButtonColor: '#008AFF'
      }).then(() => {
        // on close
      })
    }
  })
}
// post
export function postAction (url, parameter) {
  // 逐级返回时用户信息处理
  // let queryToken = getUrlKey('token', window.location.href)
  // resetUserSessionStorage(queryToken)
  let queryTm = getUrlKey('tm', window.location.href)
  resetUserSessionStorage(queryTm)
  let req = axios({
    url: url,
    method: 'post',
    data: parameter
  })
  Interceptor(req) // 拦截器方法执行
  return req
}

// get
export function getAction (url, parameter) {
  // 逐级返回时用户信息处理
  // let queryToken = getUrlKey('token', window.location.href)
  // resetUserSessionStorage(queryToken)
 let queryTm = getUrlKey('tm', window.location.href)
 resetUserSessionStorage(queryTm)

  let req = axios({
    url: url,
    method: 'get',
    params: parameter
  })
  Interceptor(req) // 拦截器方法执行
  return req
}



// WEBPACK FOOTER //
// ./src/utils/api.js